import Separator from "@components/CustomTypography/Separator/Separator"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React, {useState} from "react"

import ContentAsset from "../../ContentAsset/ContentAsset"
import StudioFeaturesNavigationBar from "../StudioFeaturesNavigationBar/StudioFeaturesNavigationBar"

// import styles from "./StudioOverviewFeaturesSlider.module.scss"

type Props = {
	data: AdvancedSideAssetMainContent[]
}

const StudioOverviewFeaturesSlider = (props: Props) => {
	const [showItem, setShowItem] = useState<number>(0)

	const changeShowedItem = (id: number): void => {
		setShowItem(id)
	}

	return (
		<div>
			<StudioFeaturesNavigationBar
				active={showItem}
				data={props.data}
				asButton
				onClick={changeShowedItem}
			/>
			<Separator size={64} />
			<ContentAsset
				data={{
					...props.data?.[showItem].insideContent,
					preview: props.data?.[showItem].insideContent?.inside,
					buttons: props.data?.[showItem].buttons,
				}}
				direction={"left"}
			/>
		</div>
	)
}

export default StudioOverviewFeaturesSlider
